var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ksa",attrs:{"id":"pdfvuer"}},_vm._l((_vm.numPages),function(i){return _c('pdf',{key:i,staticStyle:{"width":"100%","overflow":"hidden"},attrs:{"src":_vm.pdfdata,"id":i,"page":i,"scale":_vm.scale},on:{"update:scale":function($event){_vm.scale=$event}}},[_c('template',{slot:"loading"},[_vm._v("loading content here...")])],2)}),1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-aab0ad1a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/ksa.vue
// module id = 995
// module chunks = 173